import type { CommonUnionType } from '@/store/actions/common.action'
import { ROUTE_BACK, REQUEST_ERROR, REQUEST_STATUS } from '@/store/actions/common.action'

export interface ICommonState {
  fetching: boolean
  message: string
  url: string
  param: string
  state: any
}

const intialState: ICommonState = {
    fetching: true,
    message: '',
    url: '',
    param: '',
    state: ''
}

export default function commonReducer(
    state = intialState,
    action: CommonUnionType
): any {
    switch (action.type) {
        case REQUEST_STATUS:
            return {
                ...state,
                fetching: action.payload.fetching
            }
        case REQUEST_ERROR:
            return {
                ...state,
                fetching: action.payload.fetching,
                message: action.payload.message
            }
        case ROUTE_BACK:
            return {
                ...state,
                url: action.payload.url,
                param: action.payload.param,
                state: action.payload.state
            }
        default:
            return state
    }
}
